module.exports = __webpack_public_path__ + "rs.svg?af6cd01b97e20cf166e23c0980b2477b";